var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvest = function SvgInvest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.047 6.675c0-.867.704-1.57 1.571-1.57h2.812c.867 0 1.57.703 1.57 1.57v10.288h-5.953V6.675ZM0 10.287c0-.867.703-1.57 1.57-1.57h2.812c.868 0 1.57.703 1.57 1.57v6.691H0v-6.69ZM11.688 0H9.3c-.99 0-1.79.801-1.79 1.79v15.173h5.953V1.791C13.463.8 12.677 0 11.688 0Z"
  }))));
};
export default SvgInvest;